// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export function loadPage(path: string): void {
  window.location.assign(path);
}
